import styled from 'styled-components';
import { useNavigate } from 'react-router';
import { CredusText } from 'ui';

import { CredusButton, color } from 'ui';
import { CalendarIcon, ClockIcon } from '../../../assets/images/svgs';
import { TestReportOverView } from './ReportData';

interface ReportCardProps {
  test: TestReportOverView;
}

const ReportCard = ({ test }: ReportCardProps) => {
  const navigate = useNavigate();
  const handleViewReport = () => {
    navigate('/report', { state: { test } });
  };
  return (
    <Container>
      <HeaderDiv>
        <CredusText weight="medium" size="md" color={color.black}>
          {test.subjectName}
        </CredusText>
      </HeaderDiv>
      <Body>
        <CredusText weight="regular" size="xs">
          {test.description}
        </CredusText>
        <Div>
          <Detail>
            <CalendarIcon />
            <CredusText weight="regular" size="xs" color="#181819B2">
              {test.testDate}
            </CredusText>
          </Detail>
          <Detail>
            <ClockIcon />
            <CredusText weight="regular" size="xs" color="#181819B2">
              {test.testTime} GMT Nigeria
            </CredusText>
          </Detail>
        </Div>
        <BtnDiv>
          {/* <CredusButton variant="secondary">Details</CredusButton> */}
          {/* <CredusButton variant="tertiary">View Result</CredusButton> */}
          <CredusButton onClick={handleViewReport}>View Report</CredusButton>
        </BtnDiv>
      </Body>
    </Container>
  );
};

export default ReportCard;

const Container = styled.div`
  padding: 1.5rem 1.2rem;
  height: 300px;
  border-radius: 5px;
  background: ${color.white};
  box-sizing: border-box;
  position: relative;
  border: 1px solid rgba(224, 222, 247, 0.5);
`;

const HeaderDiv = styled.div`
  border-bottom: 1px solid #00000026;
  padding-bottom: 1.2rem;
  margin-bottom: 1rem;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Div = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;
const Detail = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
const BtnDiv = styled.div`
  display: flex;
  gap: 1rem;
`;
